import { Component, OnInit,ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http'; 
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-toilet-status-report',
  templateUrl: './toilet-status-report.component.html',
  styleUrls: ['./toilet-status-report.component.scss']
})
export class ToiletStatusReportComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private request : RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe:DatePipe
  ) { }

  filterZoneList: any = [];
  filterWardList: any = [];
  filterZoneIds: any[] = [];
  filterWardIds: any[] = [];

  ngOnInit(): void {
    this.ShowDate();
    this.ToiletStatusReport();
    this.ViewZone("");
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'toilet status report' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'toilet status report' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'toilet status report' 
        }
      ]
    };
  }

  async ViewZone(zone_id: any) {
    try {
      const data: any = await this.request.post('/master/view_zone_master', { zone_no: zone_id });
      const zones = [];
      if (data && data.result) {
        for (let item of data.result) {
          zones.push({
            id: item.zone_id,
            zone_name: item.zone_no + " (" + item.zone_name + ")"
          });
        }
      }
      this.filterZoneList = zones;
    } catch (error) {
      console.error(error);
    }
  }

  async onFilterZoneChange(event: any) {
    this.filterWardList = [];
    this.filterWardIds = [];
    if (!this.filterZoneIds || this.filterZoneIds.length === 0) {
      this.applyFilter();
      return;
    }
    for (let zoneId of this.filterZoneIds) {
      await this.LoadWardsForFilter(zoneId);
    }
    this.applyFilter();
  }

  async LoadWardsForFilter(zone_id: any) {
    try {
      const data: any = await this.request.post('/master/view_ward_master_by_zone', { zone_no: zone_id });
      if (data && data.result) {
        for (let ward of data.result) {
          const exists = this.filterWardList.some((x: any) => x.id === ward.ward_id);
          if (!exists) {
            this.filterWardList.push({
              id: ward.ward_id,
              ward_name: ward.ward_no + " (" + ward.ward_name + ")"
            });
          }
        }
      }
      this.filterWardList = [...this.filterWardList];
    } catch (error) {
      console.error(error);
    }
  }

  onFilterWardChange(event: any) {
    this.applyFilter();
  }

  applyFilter() {
    let filtered = [...this.inactiveDeviceData];
    if (this.filterZoneIds && this.filterZoneIds.length > 0) {
      filtered = filtered.filter(item => 
        this.filterZoneIds.includes(item.zone_id) || 
        this.filterZoneIds.includes(Number(item.zone_id)) || 
        this.filterZoneIds.includes(String(item.zone_id))
      );
    }
    if (this.filterWardIds && this.filterWardIds.length > 0) {
      filtered = filtered.filter(item => 
        this.filterWardIds.includes(item.ward_id) || 
        this.filterWardIds.includes(Number(item.ward_id)) || 
        this.filterWardIds.includes(String(item.ward_id))
      );
    }
    this.rowData = filtered;
    this.rerenderTable();
  }

  resetFilter() {
    this.filterZoneIds = [];
    this.filterWardIds = [];
    this.filterWardList = [];
    this.rowData = [...this.inactiveDeviceData];
    this.rerenderTable();
  }

  rerenderTable(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    } else {
      try {
        $('.status_table').DataTable().destroy();
      } catch (e) {}
      this.dtTrigger.next();
    }
  }

  fromDate:any;
  toDate:any;
  currentDate:any;
  ShowDate(){
    this.currentDate = this.datePipe.transform(new Date(),"yyyy-MM-dd");
    $("#fromDate").val(this.currentDate);
    $("#toDate").val(this.currentDate);
  }

  rowData:any;
  inactiveDeviceData=[];
  isLoading=false;
  async ToiletStatusReport(){
    try {
      this.isLoading=true;
      let from = this.datePipe.transform($("#fromDate").val(),"yyyy-MM-dd");
      let to = this.datePipe.transform($("#toDate").val(),"yyyy-MM-dd");
      this.fromDate = from+" 00:00:00";
      this.toDate = to+" 23:59:59";
      this.inactiveDeviceData=[];
      // const requestData = {};
      const requestData = {
        "from_date":this.fromDate,
        "to_date":this.toDate
      };
      // this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/dashboard/view_toilet_feedback_log_data_by_date', requestData);
      // const data: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', requestData);
      // this.dtTrigger.next();
      for (let objKey of Object.keys(data.result)) {
        let dataObj = data.result[objKey];
        this.inactiveDeviceData.push(dataObj);
      }
      this.rowData = this.inactiveDeviceData;
      $('.status_table').DataTable().destroy();
      this.dtTrigger.next();
      // console.log(this.rowData);
      this.isLoading=false;
    } catch (error) {}
  }

}
